import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { apiError } from "./api";

const inputCls = "w-full bg-white border border-military/20 rounded-lg px-3 py-2.5 text-sm text-military-dark focus:outline-none focus:border-military";
const labelCls = "block text-[10px] uppercase tracking-[0.2em] font-semibold text-military-dark/50 mb-1.5";

export default function Content() {
  const [form, setForm] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/content").then((r) => setForm(r.data)).catch(() => {});
  }, []);

  if (!form) return <p className="text-military-dark/50 text-sm">Carregando...</p>;

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.put("/admin/content", {
        ...form,
        motoboy_fee: form.motoboy_fee === "" || form.motoboy_fee == null ? null : Number(form.motoboy_fee),
        correios_fee: form.correios_fee === "" || form.correios_fee == null ? null : Number(form.correios_fee),
      });
      toast.success("Conteúdo do site atualizado");
    } catch (err) {
      toast.error(apiError(err));
    }
    setSaving(false);
  };

  return (
    <div data-testid="admin-content">
      <h1 className="font-serif text-3xl md:text-4xl text-military-dark mb-2">Conteúdo do site</h1>
      <p className="text-sm text-military-dark/50 mb-8">Alterações salvas aqui refletem automaticamente no site público.</p>

      <form onSubmit={save} className="space-y-8 max-w-2xl">
        <section className="bg-white border border-military/10 rounded-lg p-6">
          <p className="text-xs uppercase tracking-[0.2em] font-semibold text-military-dark/60 mb-5">Informações de contato (rodapé)</p>
          <div className="space-y-4">
            <div><label className={labelCls}>E-mail de contato</label><input data-testid="ct-email" value={form.contact_email} onChange={(e) => setForm({ ...form, contact_email: e.target.value })} className={inputCls} /></div>
            <div><label className={labelCls}>WhatsApp exibido</label><input data-testid="ct-whatsapp" value={form.whatsapp_display} onChange={(e) => setForm({ ...form, whatsapp_display: e.target.value })} className={inputCls} /></div>
            <div><label className={labelCls}>Horário de atendimento</label><input data-testid="ct-hours" value={form.hours} onChange={(e) => setForm({ ...form, hours: e.target.value })} className={inputCls} /></div>
            <div><label className={labelCls}>Cidade</label><input data-testid="ct-city" value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })} className={inputCls} /></div>
          </div>
        </section>

        <section className="bg-white border border-military/10 rounded-lg p-6">
          <p className="text-xs uppercase tracking-[0.2em] font-semibold text-military-dark/60 mb-5">Chamada promocional (faixa no topo do site)</p>
          <div className="space-y-4">
            <div><label className={labelCls}>Texto da faixa</label><input data-testid="ct-promo-text" value={form.promo_text} onChange={(e) => setForm({ ...form, promo_text: e.target.value })} placeholder="Ex.: Frete grátis em Londrina acima de R$ 199" className={inputCls} /></div>
            <label className="flex items-center gap-2 text-sm text-military-dark cursor-pointer">
              <input data-testid="ct-promo-active" type="checkbox" checked={!!form.promo_active} onChange={(e) => setForm({ ...form, promo_active: e.target.checked })} className="w-4 h-4 accent-[#4E5D46]" />
              Exibir faixa promocional no site
            </label>
          </div>
        </section>

        <section className="bg-white border border-military/10 rounded-lg p-6" data-testid="delivery-settings">
          <p className="text-xs uppercase tracking-[0.2em] font-semibold text-military-dark/60 mb-5">Entrega e retirada (checkout)</p>
          <div className="space-y-4">
            <div><label className={labelCls}>Taxa de motoboy em Londrina (R$ — vazio = a combinar)</label><input data-testid="ct-motoboy-fee" type="number" step="0.01" min="0" value={form.motoboy_fee ?? ""} onChange={(e) => setForm({ ...form, motoboy_fee: e.target.value })} className={inputCls} /></div>
            <div><label className={labelCls}>Frete Correios (R$ — vazio = informado após o pedido)</label><input data-testid="ct-correios-fee" type="number" step="0.01" min="0" value={form.correios_fee ?? ""} onChange={(e) => setForm({ ...form, correios_fee: e.target.value })} className={inputCls} /></div>
            <div><label className={labelCls}>Aviso de frete Correios</label><input data-testid="ct-correios-note" value={form.correios_note || ""} onChange={(e) => setForm({ ...form, correios_note: e.target.value })} className={inputCls} /></div>
            <div><label className={labelCls}>CEP de origem (saída da loja) — usado no cálculo Correios</label><input data-testid="ct-correios-origin" value={form.correios_origin_cep || ""} onChange={(e) => setForm({ ...form, correios_origin_cep: e.target.value })} placeholder="Ex.: 86010-150" className={inputCls} /></div>
            <div><label className={labelCls}>Endereço de retirada</label><input data-testid="ct-pickup-address" value={form.pickup_address || ""} onChange={(e) => setForm({ ...form, pickup_address: e.target.value })} className={inputCls} /></div>
            <div><label className={labelCls}>Horário de retirada</label><input data-testid="ct-pickup-hours" value={form.pickup_hours || ""} onChange={(e) => setForm({ ...form, pickup_hours: e.target.value })} className={inputCls} /></div>
            <div><label className={labelCls}>Instruções de retirada</label><input data-testid="ct-pickup-instructions" value={form.pickup_instructions || ""} onChange={(e) => setForm({ ...form, pickup_instructions: e.target.value })} className={inputCls} /></div>
          </div>
        </section>

        <section className="bg-white border border-military/10 rounded-lg p-6" data-testid="prelaunch-settings">
          <p className="text-xs uppercase tracking-[0.2em] font-semibold text-military-dark/60 mb-5">Lançamento da loja</p>
          <label className="flex items-center gap-2 text-sm text-military-dark cursor-pointer">
            <input data-testid="ct-prelaunch" type="checkbox" checked={!!form.prelaunch_mode} onChange={(e) => setForm({ ...form, prelaunch_mode: e.target.checked })} className="w-4 h-4 accent-[#4E5D46]" />
            Ativar modo pré-lançamento — site exibe "Em breve" e as compras ficam bloqueadas
          </label>
          <p className="text-xs text-military-dark/45 mt-2 leading-relaxed">O painel administrativo continua liberado normalmente. Desative quando a loja estiver pronta para vender.</p>
        </section>

        <section className="bg-white border border-military/10 rounded-lg p-6">
          <p className="text-xs uppercase tracking-[0.2em] font-semibold text-military-dark/60 mb-5">Estoque no site</p>
          <label className="flex items-center gap-2 text-sm text-military-dark cursor-pointer">
            <input data-testid="ct-show-oos" type="checkbox" checked={!!form.show_out_of_stock} onChange={(e) => setForm({ ...form, show_out_of_stock: e.target.checked })} className="w-4 h-4 accent-[#4E5D46]" />
            Manter produtos esgotados visíveis no site (com selo "Esgotado")
          </label>
        </section>

        <section className="bg-white border border-military/10 rounded-lg p-6">
          <p className="text-xs uppercase tracking-[0.2em] font-semibold text-military-dark/60 mb-5">E-mail de avaliação</p>
          <label className="flex items-center gap-2 text-sm text-military-dark cursor-pointer">
            <input data-testid="ct-review-invite" type="checkbox" checked={form.review_invite_enabled !== false} onChange={(e) => setForm({ ...form, review_invite_enabled: e.target.checked })} className="w-4 h-4 accent-[#4E5D46]" />
            Enviar convite de avaliação por e-mail após cada pedido
          </label>
        </section>

        <button data-testid="content-save" type="submit" disabled={saving} className="rounded-full bg-military-dark text-offwhite px-8 py-3.5 text-sm uppercase tracking-widest font-semibold hover:bg-military transition-colors disabled:opacity-50">
          {saving ? "Salvando..." : "Salvar alterações"}
        </button>
      </form>
    </div>
  );
}
